import React, { useState } from "react";
import { Image } from "antd";
import { routes } from "../../Routes";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { store } from "../../Redux/store";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const { i18n, t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { login } = store.getState();
  const user_id = login.user;
  const is_retailer = login.user?.result?.is_retailer;

  const navigate = useNavigate();

  return (
    <>
      <header
        className="sticky top-0 z-[60] border-b border-[#E2E8F0]"
        style={{
          background: "rgba(255,255,255,.92)",
          backdropFilter: "blur(10px)",
          WebkitBackdropFilter: "blur(10px)",
        }}
      >
        <div className="max-w-[1180px] mx-auto px-5">
          <div className="flex items-center justify-between py-[14px] gap-5">

            {/* Logo */}
            <a
              href="/"
              aria-label="Hisabak home"
              className="flex items-center"
            >
              <Image
                src="https://hisabak.com/static/media/hisabakLogo.35953b144495459dcc84.png"
                alt="Hisabak logo"
                width={140}
                height={38}
                preview={false}
              />
            </a>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-7">
              {[
                { label: t("Features"), href: "#features" },
                { label: t("How it works"), href: "#how-it-works" },
                { label: t("Industries"), href: "#industries" },
                { label: t("Pricing"), href: "#pricing" },
                { label: t("About us"), href: "/about" },
                { label: t("FAQ"), href: "#faqs" },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="font-medium text-[15px] text-[#475569] transition-colors duration-150 hover:text-[#1B4597]"
                >
                  {item.label}
                </a>
              ))}
            </nav>

            {/* Desktop CTA */}
            <div className="hidden lg:flex items-center gap-[10px]">

              {/* Language Switcher */}
              <div className="flex gap-[6px]">
                <button
                  onClick={() => i18n.changeLanguage("en")}
                  className={`text-[12px] px-[10px] py-[4px] rounded-[6px] border font-medium transition-all ${
                    i18n.language === "en"
                      ? "bg-[#0F172A] text-white border-[#0F172A]"
                      : "text-[#475569] border-[#E2E8F0]"
                  }`}
                >
                  EN
                </button>

                <button
                  onClick={() => i18n.changeLanguage("ar")}
                  className={`text-[12px] px-[10px] py-[4px] rounded-[6px] border font-medium transition-all ${
                    i18n.language === "ar"
                      ? "bg-[#0F172A] text-white border-[#0F172A]"
                      : "text-[#475569] border-[#E2E8F0]"
                  }`}
                >
                  عربي
                </button>
              </div>

              {user_id ? (
                <button
                  onClick={() => {
                    if (is_retailer === false) {
                      navigate(routes.orders);
                    } else {
                      navigate(routes.dashboard);
                    }
                  }}
                  className="inline-flex items-center justify-center px-[18px] py-[11px] rounded-[10px] font-semibold text-[14.5px] bg-[#1B4597] text-white transition-all duration-200 hover:-translate-y-[1px] hover:shadow-[0_8px_20px_rgba(37,99,235,.35)]"
                >
                  {t("Go to Dashboard")}
                </button>
              ) : (
                <>
                  <button
                    onClick={() => navigate(routes.login)}
                    className="inline-flex items-center justify-center px-[18px] py-[11px] rounded-[10px] border border-[#E2E8F0] text-[#0F172A] font-semibold text-[14.5px] transition-all duration-200 hover:border-[#0F172A]"
                  >
                    {t("Login")}
                  </button>

                  <a
                    href="https://wa.me/201004505666?text=I%20want%20a%20demo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center px-[18px] py-[11px] rounded-[10px] font-semibold text-[14.5px] bg-[#1B4597] text-white transition-all duration-200 hover:bg-[#1B4597] hover:-translate-y-[1px] hover:shadow-[0_8px_20px_rgba(37,99,235,.35)]"
                  >
                    {t("Get Started Free")}
                  </a>
                </>
              )}
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-[#0F172A]"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Open menu"
            >
              {isMenuOpen ? (
                <X className="w-6 h-6" />
              ) : (
                <Menu className="w-6 h-6" />
              )}
            </button>
          </div>

          {/* Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden border-t border-[#E2E8F0] py-4 flex flex-col gap-1">

              {[
                { label: t("Features"), href: "#features" },
                { label: t("How it works"), href: "#how-it-works" },
                { label: t("Industries"), href: "#industries" },
                { label: t("Pricing"), href: "#pricing" },
                { label: t("About us"), href: "/about" },
                { label: t("FAQ"), href: "#faqs" },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setIsMenuOpen(false)}
                  className="px-4 py-[10px] rounded-lg text-[14.5px] font-medium text-[#475569] hover:bg-[#F8FAFC]"
                >
                  {item.label}
                </a>
              ))}

              <div className="flex gap-2 px-4 pt-3">
                <button
                  onClick={() => i18n.changeLanguage("en")}
                  className={`text-[12px] px-[10px] py-[5px] rounded-[6px] border ${
                    i18n.language === "en"
                      ? "bg-[#0F172A] text-white border-[#0F172A]"
                      : "border-[#E2E8F0]"
                  }`}
                >
                  EN
                </button>

                <button
                  onClick={() => i18n.changeLanguage("ar")}
                  className={`text-[12px] px-[10px] py-[5px] rounded-[6px] border ${
                    i18n.language === "ar"
                      ? "bg-[#0F172A] text-white border-[#0F172A]"
                      : "border-[#E2E8F0]"
                  }`}
                >
                  عربي
                </button>
              </div>

              <div className="border-t border-[#E2E8F0] mt-3 pt-3 px-4 flex flex-col gap-2">
                {user_id ? (
                  <button
                    onClick={() => navigate(routes.dashboard)}
                    className="w-full py-3 rounded-[10px] bg-[#1B4597] text-white font-semibold"
                  >
                    {t("Go to Dashboard")}
                  </button>
                ) : (
                  <>
                    <button
                      onClick={() => navigate(routes.login)}
                      className="w-full py-3 rounded-[10px] border border-[#E2E8F0] font-semibold"
                    >
                      {t("Login")}
                    </button>

                    <a
                      href="https://wa.me/201004505666?text=I%20want%20a%20demo"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-full py-3 rounded-[10px] bg-[#1B4597] text-white font-semibold text-center"
                    >
                      {t("Get Started Free")}
                    </a>
                  </>
                )}
              </div>
            </div>
          )}
        </div>
      </header>
    </>
  );
};

export default Navbar;